import { namespacer } from 'helpers'

const namespace = namespacer('SETTINGS')
export const LOAD_SETTINGS_SUCCESS = namespace('LOAD_SETTINGS_SUCCESS')
export const LOAD_SETTINGS_ERROR = namespace('LOAD_SETTINGS_ERROR')
